import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GerenteGuard implements CanActivate {
  constructor(private router: Router,
    private authService: AuthenticationService) { }

  canActivate() {
    const user = this.authService.getCurrentUser();
    if (user && user.roles[0].name == 'gerente') {
      return true;

    } else {
      this.router.navigate(['/']);
      return false;
    }
  }

}
